// Pe produsele cu variante (culoare/marime), Horizon preselecteaza automat
// prima varianta din lista. Asta poate duce la comanda din greseala a
// variantei gresite daca clientul nu observa selectia implicita.
//
// Acest script: (1) deselecteaza orice radio de varianta preselectat automat
// la incarcarea paginii, (2) dezactiveaza butonul "Adauga in cos" pana cand
// clientul alege explicit o varianta printr-un click real.
(function () {
  function guardProductInfo(productInfo) {
    if (productInfo.dataset.atGuarded === 'true') return;

    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    var radios = variantSelects.querySelectorAll('input[type="radio"]');
    if (!radios.length) return; // produs fara swatch-uri (dropdown sau default)

    // Butonul real "Adauga in cos" are id="ProductSubmitButton-<section>"
    // (vezi buy-buttons.liquid) — cautam dupa asta in loc de a incerca sa
    // gasim formularul corect (pagina mai are si un <form> decorativ pentru
    // plata in rate, care se potrivea din greseala pe prefixul product-form-).
    var submitButtons = productInfo.querySelectorAll('button[id^="ProductSubmitButton-"]');

    if (!submitButtons.length) return;

    productInfo.dataset.atGuarded = 'true';

    // Deselecteaza orice radio bifat automat de tema la randare.
    radios.forEach(function (radio) {
      radio.checked = false;
    });

    // Dezactiveaza butoanele de cumparare pana la o alegere reala.
    submitButtons.forEach(function (btn) {
      btn.dataset.atGuardDisabled = 'true';
      btn.disabled = true;
    });

    // La primul click pe orice radio din acest formular, reactiveaza butoanele.
    var onPick = function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        submitButtons.forEach(function (btn) {
          if (btn.dataset.atGuardDisabled === 'true') {
            btn.disabled = false;
            delete btn.dataset.atGuardDisabled;
          }
        });
        variantSelects.removeEventListener('change', onPick);
      }
    };
    variantSelects.addEventListener('change', onPick);
  }

  function guardAll() {
    document.querySelectorAll('product-info').forEach(guardProductInfo);
  }

  // Scriptul e incarcat cu "defer", deci DOMContentLoaded poate fi deja trecut
  // cand ajunge sa ruleze — verificam starea documentului direct in loc sa ne
  // bazam doar pe evenimente care poate au fost deja emise.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardAll);
  } else {
    guardAll();
  }
  // Section Rendering (schimbarea variantei/paginare) re-randeaza sectiunea;
  // reaplicam guard-ul cand Shopify anunta actualizarea sectiunii.
  document.addEventListener('shopify:section:load', guardAll);
  // Fallback: si dupa incarcarea completa a paginii (scripturi deferred).
  window.addEventListener('load', guardAll);
})();
